import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import mockup from "../../assets/img/kpmobil-mockup-new.png"

import OtherCaseStudy from "../../components/other-case"

import sedef from "../../assets/img/teams/19.jpg"
import melisa from "../../assets/img/teams/18.jpg"
import seher from "../../assets/img/teams/04.jpg"
import gulse from "../../assets/img/teams/48.jpg"


const ReferancesDetail = () => (
    <Layout>
        <SEO title="Kentpark Success Story | Flatart" />
        <div className="referances-detail py60 container">
            <div className="col-md-5 detail-left">
                <b>SUCCESS STORY</b>
                <h1 style={{ margin: '20px auto 20px' }}>Kentpark AVM</h1>
                <p style={{ maxWidth: 420}}>We set out with the idea of developing a special project for Women's Day for Kentpark Shopping Mall, one of Ankara's most distinguished shopping centers. Our goal here was to give the followers of our high-brand-awareness mall a different experience on Women's Day.</p>

                </div>
            <div className="col-md-7 referances-boxs">
                <div className="provided">
                    <h3 style={{ margin: '10px 0' }} >Services Provided</h3>
                    <div className="provided-box">
                        <div className="box">
                            <Link to="/social-media/"></Link>
                            <svg id="instagram-logo" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 61.312 61.312">
                                <path id="Path_36346" data-name="Path 36346" d="M44.392,0H16.92A16.939,16.939,0,0,0,0,16.92V44.392a16.939,16.939,0,0,0,16.92,16.92H44.392a16.939,16.939,0,0,0,16.92-16.92V16.92A16.939,16.939,0,0,0,44.392,0ZM55.872,44.392a11.493,11.493,0,0,1-11.48,11.48H16.92A11.493,11.493,0,0,1,5.44,44.392V16.92A11.493,11.493,0,0,1,16.92,5.44H44.392a11.493,11.493,0,0,1,11.48,11.48V44.392Z" />
                                <path id="Path_36347" data-name="Path 36347" d="M56.767,40.97a15.8,15.8,0,1,0,15.8,15.8A15.816,15.816,0,0,0,56.767,40.97Zm0,26.156A10.358,10.358,0,1,1,67.125,56.768,10.37,10.37,0,0,1,56.767,67.126Z" transform="translate(-26.111 -26.112)" />
                                <path id="Path_36348" data-name="Path 36348" d="M122.91,28.251a3.987,3.987,0,1,0,2.821,1.168A4,4,0,0,0,122.91,28.251Z" transform="translate(-75.793 -18.005)" />
                            </svg>
                            Social Media
                        </div>
                    </div>
                </div>
                <div className="project-details">
                    <h3 style={{ margin: '1px 0' }}>Impressum</h3>
                    <div className="project-details_list">
                        <ul>
                            <li>Brand Strategist:</li>
                            <li>Project Manager:</li>
                            <li>Project Manager:</li>
                            <li>Digital Designer:</li>
                        </ul>
                        <ul>
                            <li><img src={melisa} />Melisa Akınsal</li>
                            <li><img src={seher} />Seher Taylan</li>
                            <li><img src={sedef} />Sedef Çelik</li>
                            <li><img src={gulse} />Gülse Erdek</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
        <div className="container">

            <div className="content-section content row" >
                <div className="col-md-6">
                    <img className="pr100" src={mockup} />
                </div>
                <div className="col-md-6">
                    <p className="small" style={{color:"#ea4f6a" }} >Success Story</p>
                    <p style={{ maxWidth: 429 }} >To that end, we created a custom AR filter for our page and asked, "Which Powerful Woman Are You?" We asked our followers who used the filter to share their results by tagging our page.</p>
                </div>
            </div>
            <div style={{ margin: '50px auto 50px' }} className="text-center">
                <h2 style={{color:"#ea4f6a" }} >Which Powerful Woman Are You?</h2>
                <p style={{color:"#ea4f6a", fontSize: 18}} >Success Story</p>
                <p style={{ fontSize: 18, margin: '7px auto 10px', maxWidth: 800 }} >With our project, we connected +100,000 people with our brand within 3 days. Our AR filter themed "Which Powerful Woman Are You?" was viewed 18,963 times. 2,232 people who wanted to see which powerful woman from history they resembled tried our filter.</p>
            </div>
            <div className="referances-detail container" >
            <div className="col-md-1">
            </div>
            <div className="col-md-10 referances-boxs">
                <div className="boxs" style={{ marginBottom: '0' }}>
                    <div className="box" style={{ width:220}} >
                        <span>+100k</span>
                        <p>People Connected with Our Brand</p>
                    </div>
                    <div className="box" style={{ width:220}}>
                        <span>18.963</span>
                        <p>Number of Views</p>
                    </div>
                    <div className="box" style={{ width:220}}>
                        <span>2.323</span>
                        <p>People Tried Our Filter</p>
                    </div>
                </div>
            </div>
            <div className="col-md-1">
            </div>
        </div>
        <div style={{ margin: '50px auto 50px' }} className="text-center">
                <p style={{color:"#ea4f6a", fontSize: 18}} >Success Story</p>
                <p style={{ fontSize: 18, margin: '7px auto 10px', maxWidth: 800 }} >In doing so, on Women's Day we successfully matched important women from our history with our followers, creating a wonderful experience for them. At the same time, we reached people who were not yet following our page and gained new followers.</p>
            </div>
        </div>


        <OtherCaseStudy />

        <Checkup />
    </Layout >
)

export default ReferancesDetail
